<template>
  <div class="flex flex-col w-full">
    <div class="w-full" v-if="!showError">
      <div v-if="advanceTabs.length > 0" class="w-full flex flex-col mt-2 py-5">
        <div 
          class="bg-white border-b border-gray-200"
        >
          <div class="mt-1">
            <Tab
              :tabs="tabs"
              border
              :active-tab="AdvancesCurrentTab"
              @currentTab="handleCurrentTab($event)"
            />
          </div>
        </div>

        <div class="w-full"
          v-for="(advanceTab, index) in advanceTabs"
          :key="index"
        >
          <div v-if="AdvancesCurrentTab === advanceTab">
            <loader v-if="isloading" size="xxs" :loader-image="false" />
            <div v-else>
              <div class="px-6 pt-6" v-if="stats">
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                  <!-- Total Loan Disbursed - Primary Stat Card -->
                  <Card
                    class="rounded-xl p-5 border border-gray-100 flex flex-col justify-center items-start"
                    style="
                      box-shadow: -6px 9px 24px 0px #0000000f;
                      background-color: #fcf4ff;
                    "
                  >
                    <div class="flex items-start justify-between mb-3">
                      <div>
                        <Icon
                          icon-name="money_bag"
                          class-name="text-purple-600"
                          size="xs"
                        />
                      </div>
                    </div>
                    <div
                      class="text-xs font-semibold text-romanSilver uppercase tracking-wide"
                    >
                      Total Advance Disbursed (YTD)
                    </div>
                    <div class="text-2xl font-bold text-jet">
                      {{ convertToCurrency(stats.totalLoanDisbursed || 0) }}
                    </div>
                  </Card>

                  <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:col-span-3">
                    <!-- Left Column: Outstanding Repayment & Pending Requests -->
                    <div class="flex flex-col gap-2">
                      <!-- Outstanding Repayment -->
                      <Card
                        class="bg-white rounded-lg p-3 border border-gray-100 flex flex-col justify-start items-start"
                        style="box-shadow: -6px 9px 24px 0px #0000000f"
                      >
                        <div class="flex gap-1">
                          <div class="w-6 h-6">
                            <Icon class="icon-stat"
                              icon-name="wallet-money"
                              class-name="text-orange-600"
                              size="xs"
                            />
                          </div>
                          <div
                            class="text-xs font-semibold text-romanSilver uppercase tracking-wide"
                          >
                            Outstanding Repayment (YTD)
                          </div>
                        </div>
                        <div class="text-base font-bold text-jet pl-7 m-top">
                          {{
                            convertToCurrency(stats.outstandingRepayment || 0)
                          }}
                        </div>
                      </Card>

                      <!-- Pending Requests -->
                      <Card
                        class="bg-white rounded-lg p-3 border border-gray-100 flex flex-col justify-start items-start"
                        style="box-shadow: -6px 9px 24px 0px #0000000f"
                      >
                        <div class="flex gap-1">
                          <div class="w-6 h-6">
                            <Icon class="icon-stat"
                              icon-name="status-cancelled"
                              class-name="text-orange-600"
                              size="xs"
                            />
                          </div>
                          <div
                            class="text-xs font-semibold text-romanSilver uppercase tracking-wide"
                          >
                            Pending Requests
                          </div>
                        </div>
                        <div class="text-base font-bold text-jet pl-7 m-top">
                          {{ stats.pendingRequests || 0 }}
                        </div>
                      </Card>
                    </div>

                    <!-- Right Column: Approved & Disapproved Requests -->
                    <div class="flex flex-col gap-2">
                      <!-- Approved Requests -->
                      <Card
                        class="bg-white rounded-lg p-3 border border-gray-100 flex flex-col justify-start items-start"
                        style="box-shadow: -6px 9px 24px 0px #0000000f"
                      >
                        <div class="flex gap-1">
                          <div class="w-6 h-6">
                            <Icon class="icon-stat"
                              icon-name="success-filled"
                              class-name="text-orange-600"
                              size="xs"
                            />
                          </div>
                          <div
                            class="text-xs font-semibold text-romanSilver uppercase tracking-wide"
                          >
                            Approved
                          </div>
                        </div>
                        <div class="text-base font-bold text-jet pl-7 m-top">
                          {{ stats.approvedRequests || 0 }}
                        </div>
                      </Card>

                      <!-- Disapproved Requests -->
                      <Card
                        class="bg-white rounded-lg p-3 border border-gray-100 flex flex-col justify-start items-start"
                        style="box-shadow: -6px 9px 24px 0px #0000000f"
                      >
                        <div class="flex gap-1">
                          <div class="w-6 h-6">
                            <Icon class="icon-stat"
                              icon-name="cancel"
                              class-name="text-orange-600"
                              size="xs"
                            />
                          </div>
                          <div
                            class="text-xs font-semibold text-romanSilver uppercase tracking-wide"
                          >
                            Disapproved
                          </div>
                        </div>
                        <div class="text-base font-bold text-jet pl-7 m-top">
                          {{
                            stats.disapprovedRequests !== undefined
                              ? stats.disapprovedRequests
                              : stats.dissapprovedRequests || 0
                          }}
                        </div>
                      </Card>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex justify-end items-end my-8">
                <button
                  class="ml-3 px-4 py-2 bg-dynamicBackBtn text-white text-sm font-medium rounded-lg transition-colors"
                  title="Export advance data"
                  @click="handleExportData"
                >
                  Export
                </button>
              </div>

              <card>
                <template v-slot:footer>
                  <CardFooter
                    reloadcard
                    printcard
                    @reload="reload"
                    @actionModal="viewFilterTable($event)"
                    @searchResult="handleSearch($event)"
                  >
                  </CardFooter>
                </template>
              </card>

              <card class="w-full mt-10">
                <div class="flex flex-col">
                  <div
                    class="w-full flex flex-col"
                    v-if="requests.length !== 0 || loading"
                  >
                    <Table
                      :headers="header"
                      :items="requests"
                      class="w-full mt-4 mb-4"
                      aria-label="request table"
                      :has-number="true"
                      :loading="loading"
                      :pagination-list="metaData"
                      @page="handlePage($event)"
                      page-sync
                      @itemsPerPage="handleItemsPerPage($event)"
                    >
                      <template v-slot:item="{ item }">
                        <div
                          v-if="item.employee"
                          class="flex content-center"
                          style="width: 200px"
                        >
                          <div>
                            <img
                              class=""
                              :src="item.data.employee.photo"
                              alt="photo"
                              v-if="item.data.employee.photo"
                              style="height: 30px; width: 30px; border-radius: 5px"
                            />
                            <div
                              style="height: 30px; width: 30px; border-radius: 5px"
                              class="text-blueCrayola border text-center font-semibold pt-2"
                              v-else
                            >
                              {{
                                $getInitials(
                                  `${item.data.employee.fname} ${item.data.employee.lname}`
                                )
                              }}
                            </div>
                          </div>
                          <div class="flex flex-col">
                            <span
                              class="font-bold cursor-pointer ml-2 capitalize"
                              style="color: #321c3b"
                              >{{ item.data.employee.fname }}
                              {{ item.data.employee.lname }}</span
                            >
                            <span
                              class="cursor-pointer ml-2 capitalize text-gray-500"
                              >{{
                                item.data.employee.userDesignation
                                  ? item.data.employee.userDesignation.name
                                  : "-----"
                              }}</span
                            >
                          </div>
                        </div>
                        <div v-if="item.createdAt" class="capitalize">
                          <span>
                            {{
                              $DATEFORMAT(
                                new Date(item.data.createdAt),
                                "MMMM dd, yyyy"
                              )
                            }}
                          </span>
                        </div>
                        <div v-if="item.principalAmount">
                          <span>
                            {{ convertToCurrency(item.data.principalAmount) }}
                          </span>
                        </div>
                        <div v-if="item.interestRate">
                          <p>
                            {{ item.data.interestRate }}%
                          </p>
                        </div>
                        <div v-if="item.interestAmount">
                          <p>
                            {{ convertToCurrency(item.data.interestAmount) }}
                          </p>
                        </div>
                        <div v-if="item.repaymentAmount">
                          <p>
                            {{ convertToCurrency(item.data.repaymentAmount) }}
                          </p>
                        </div>
                        <div v-if="item.repaymentDuration">
                          <p>
                            {{ item.data.repaymentDuration }}
                          </p>
                        </div>
                        <div
                          v-if="item.approvalStatus"
                          style="width: 100px"
                          class="p-3"
                          :class="{
                            pending: item.data.approvalStatus === 'pending',
                            approved: item.data.approvalStatus === 'approved',
                            disapproved: item.data.approvalStatus === 'disapproved',
                          }"
                        >
                          <div class="w-auto capitalize flex flex-col">
                            <p class="text-sm font-semibold">
                              {{ Capitalize(item.data.approvalStatus) }}
                            </p>
                          </div>
                        </div>
                        <span v-else-if="item.id">
                          <Menu left top="-150" margin="24" class="my-2 p-0">
                            <template v-slot:title>
                              <icon icon-name="more_icon" size="xs" />
                            </template>
                            <div
                              class="w-48 flex flex-col justify-start items-center gap-3 px-3 py-2"
                            >
                              <div
                                class="w-full"
                                @click="checkPrivileges('view', item.data.id)"
                              >
                                <div
                                  class="w-full flex justify-start items-center gap-2 cursor-pointer"
                                >
                                  <Icon
                                    icon-name="icon-eye"
                                    class-name="text-blueCrayola"
                                    size="xs"
                                  />
                                  <p class="font-normal text-sm text-darkPurple">
                                    View Details
                                  </p>
                                </div>
                              </div>
                              <div
                                class="w-full"
                                @click="checkPrivileges('approval', item.data.id)"
                              >
                                <div
                                  class="w-full flex justify-start items-center gap-2 cursor-pointer"
                                >
                                  <Icon
                                    icon-name="icon-upgrade"
                                    class-name="text-mediumSeaGreen"
                                    size="xs"
                                  />
                                  <p class="font-normal text-sm text-darkPurple">
                                    Approval Status
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Menu>
                        </span>
                      </template>
                    </Table>
                  </div>
                  <div
                    class="w-full flex flex-col mt-4 p-2 justify-center items-center"
                    v-else
                  >
                    <p class="text-base my-2">
                      There are no Advance requests at the moment.
                    </p>
                  </div>
                </div>
              </card>
            </div> 
          </div>
        </div>
      </div>
      <AdvanceLoanEmptyState v-else type="Advance"/>
    </div>
    <div v-else>
      <ErrorPage />
    </div>

    <FilterTable
      v-if="filterTable"
      :filter-data="filterArray"
      @close="closeFilter($event)"
      @getParams="searchFilter($event)"
    />
    <advance-timeline
      :timeline-data="advanceTimeline"
      :open-modal="openModal"
      @close="openModal = false"
      slug="Advance"
      v-if="openModal"
    />
    <ApprovalProgress ref="approval_status" :mode="mode" />
  </div>
</template>

<script>
import Table from "@scelloo/cloudenly-ui/src/components/table";
import Tab from "@scelloo/cloudenly-ui/src/components/tab";
import Card from "@/components/Card";
import Icon from "@/components/Icon";
import CardFooter from "@/components/CardFooter";
import FilterTable from "@/components/FilterTable";
import Menu from "@scelloo/cloudenly-ui/src/components/Menu";
import ErrorPage from "@/modules/Admin/error403";
import AdvanceTimeline from "@/components/modals/AdvanceTimeline";

export default {
  name: "Advance",
  components: {
    Table,
    Tab,
    Card,
    FilterTable,
    Icon,
    Menu,
    ErrorPage,
    CardFooter,
    AdvanceTimeline,
    ApprovalProgress: () => import("@/components/ApprovalStatus"),
    AdvanceLoanEmptyState: () => import("./AdvanceLoanEmptyState"),
  },
  props: {
    mode: {
      type: String,
      default: "admin",
    },
  },
  data() {
    return {
      paySettingId: "",
      showError: false,
      isloading: false,
      metaData: {},
      header: [
        { title: "EMPLOYEE", value: "employee" },
        { title: "Date Requested", value: "createdAt" },
        { title: "Principal Amount", value: "principalAmount" },
        { title: "Interest Rate (P/A)", value: "interestRate" },
        { title: "Interest Amount", value: "interestAmount" },
        { title: "Total Repayable", value: "repaymentAmount" },
        { title: "Repayment Period", value: "repaymentDuration" },
        { title: "Status", value: "approvalStatus" },
        { title: "", value: "id", image: true },
      ],
      requests: [],
      allRequests: [],
      itemsPerPage: 50,
      searchWord: null,
      numberOfPage: 1,
      stats: null,
      query: "type=advance",
      loading: true,
      filterArray: [
        { header: "Location(s)", value: "locationId", optionsBox: [] },
        { header: "Level(s)", value: "levelId", optionsBox: [] },
        { header: "Function(s)", value: "functionId", optionsBox: [] },
        { header: "Designation(s)", value: "designationId", optionsBox: [] },
        { header: "Status", value: "status", optionsBox: [] },
      ],
      filterTable: false,
      openModal: false,
      AdvancesCurrentTab: "", 
      advanceTabs: [],
    };
  },
  computed:{
    tabs() {
      return this.advanceTabs;
    },
  },
  methods: {
    handleCurrentTab(currentTab) {
      this.AdvancesCurrentTab = currentTab;
      this.getRequests("&page=1&perPage=50")
    },
    async checkPrivileges(slug, id) {
      switch (slug) {
        case "approval":
          try {
            if (this.mode === "admin") {
              await this.$handlePrivilege("advance", "viewApprovalFlow");
            }
            this.openApprovalModal(id);
          } catch (error) {
            this.$toasted.error(
              "You do not have permission to perform this task",
              {
                duration: 5000,
              }
            );
          }
          break;

        case "view":
          try {
            if (this.mode === "admin") {
              await this.$handlePrivilege("advance", "viewDetails");
            }
            this.openSideModal(id);
          } catch (error) {
            this.$toasted.error(
              "You do not have permission to perform this task",
              {
                duration: 5000,
              }
            );
          }
        default:
          break;
      }
    },

    openSideModal(id) {
      const findRequest = this.initialRequests.find(
        (item) => item.id === id
      );
      if (findRequest) {
        this.advanceTimeline = this.getTimelineRequest(findRequest);
        this.openModal = true;
      } else {
        this.$toasted.error("Request not found!");
      }
    },
    openApprovalModal(id) {
      this.$refs.approval_status.toggle(id);
    },
    handleItemsPerPage(itemNo) {
      this.itemsPerPage = itemNo;
      this.queryUpdate();
    },
    handlePage(pageNumber) {
      this.numberOfPage = pageNumber;
      this.queryUpdate();
    },
    handleSearch(searchWord) {
      if (searchWord) {
        this.searchWord = searchWord;
        this.queryUpdate();
      } else {
        this.searchWord = null;
        this.queryUpdate();
      }
    },

    queryUpdate() {
      const search = this.searchWord ? `&search=${this.searchWord}` : "";
      const pageNumber = this.numberOfPage
        ? `&page=${this.numberOfPage}`
        : `&page=${this.metaData.page}`;
      const itemPage = this.itemsPerPage ? `&perPage=${this.itemsPerPage}` : "";
      this.getRequests(`${pageNumber}${itemPage}${search}`);
    },
    getTimelineRequest(result) {
      let outstandingSum = 0;
      const scheduleData = result.repaymentSchedule.map((v) => ({
        scheduleDate: v.repaymentDate,
        amount: v.totalAmount,
        status: v.paymentStatus,
      }));
      this.repaymentSchedule = scheduleData;

      scheduleData.forEach((a) => {
        if (a.status === "pending") {
          outstandingSum += a.amount;
        }
      });
      return {
        paySetting: result.paySetting.nameOnPayslip,
        rate: result.interestRate,
        amount: result.principalAmount,
        repayment: result.repaymentAmount,
        advanceType: result.type,
        duration: result.repaymentDuration,
        repaymentTime: result.firstRepaymentDate,
        requestDate: result.createdAt,
        status: result.approvalStatus,
        outstanding: outstandingSum,
        repaymentSchedule: scheduleData,
        userId: result.userId,
        ...result.user,
      };
    },

    getRequests(params) {
      this.loading = true;
      this.isloading = true;
      if (this.mode !== "ess") {
        this.$_getAdminEmployeesAdvance(params)
          .then(({ data }) => {
            this.reuseRequest(data);
          })
          .catch(() => {
            this.loading = false;
            this.isloading = false;
          });
      } else {
        this.$_getManagerEmployeesAdvance(params)
          .then(({ data }) => {
            this.reuseRequest(data);
          })
          .catch(() => {
            this.loading = false;
            this.isloading = false;
          });
      }
    },
    reuseRequest(data){
      this.AdvancesCurrentTab = !this.AdvancesCurrentTab ? data.data[0].name : this.AdvancesCurrentTab;
      this.advanceTabs = data.data.map(el => el.name);
      const requestData = data.data.filter(el => el.name === this.AdvancesCurrentTab);
      this.stats = requestData[0];
      this.requests = requestData[0].data;
      this.initialRequests = requestData[0].data;
      this.requests = this.requests.map((element) => ({
        employee: element.user,
        ...element,
      }));
      this.metaData =  requestData[0].meta;
      this.paySettingId = requestData[0].paySettingId;
      this.loading = false;
      this.isloading = false;
    },
    // getStats() {
    //   if (this.mode === "ess") {
    //     this.$_getManagerEmployeesAdvanceSummary().then((response) => {
    //       this.stats = response.data;
    //     });
    //   } else {
    //     this.$_getAdminEmployeesAdvanceStats().then((response) => {
    //       this.stats = response.data;
    //     });
    //   }
    // },
    reload() {
      this.requestAdvance();
    },

    async handleExportData(){
      const type = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const extension = ".xlsx"
      try {
        if (this.mode !== "ess") {
          const { data } = await this.$_exportAdminAdvancesAndLoansEmployees(this.paySettingId, "&page=1&perPage=50");
          const name = 'Employees Advance';
          this.$exportFile(data, name, type, extension);
          this.$toasted.success("Data exported successfully!", { duration: 5000 });
        }else{
          const { data } = await this.$_exportManagerAdvancesAndLoansEmployees(this.paySettingId);
          const name = 'Employees Advance';
          this.$exportFile(data, name, type, extension);
          this.$toasted.success("Data exported successfully!", { duration: 5000 });
        }
      } catch (error) {
        const decodedData = new TextDecoder().decode(error.response.data);
        const errorMessage = JSON.parse(decodedData);
        this.$toasted.error(errorMessage.message, { duration: 5000 });
      }
    },

    async requestAdvance() {
      if (this.mode === "ess") {
        this.showError = false;
        this.getRequests("&page=1&perPage=50");
        // this.getStats();
        return;
      }
      try {
        await this.$handlePrivilege("advance", "viewRegister");
        this.showError = false;
        this.getRequests("&page=1&perPage=50");
        // this.getStats();
      } catch (error) {
        this.showError = true;
      }
    },

    viewFilterTable(value) {
      if (value) {
        this.filterTable = true;
      }
    },

    getAllFunctions() {
      this.$_getFunction().then((response) => {
        response.data.functions.map((functionVal) => {
          this.filterArray.forEach((filter) => {
            if (filter.header === "Function(s)") {
              filter.optionsBox.push({
                id: functionVal.id,
                name: functionVal.name,
              });
            }
          });
          return {};
        });
      });
    },

    getAllDesignations() {
      this.$_getDesignations("").then((response) => {
        response.data.designations.map((designation) => {
          this.filterArray.forEach((filter) => {
            if (filter.header === "Designation(s)") {
              filter.optionsBox.push({
                id: designation.id,
                name: designation.name,
              });
            }
          });
          return {};
        });
      });
    },

    getAllLocations() {
      this.$_getHumanarLocations("").then((response) => {
        response.data.outlets.map((outlet) => {
          this.filterArray.forEach((filter) => {
            if (filter.header === "Location(s)") {
              filter.optionsBox.push({
                id: outlet.id,
                name: outlet.name,
              });
            }
          });
          return {};
        });
      });
    },

    getAllLevels() {
      this.$_getLevels().then((response) => {
        response.data.levels.map((outlet) => {
          this.filterArray.forEach((filter) => {
            if (filter.header === "Level(s)") {
              filter.optionsBox.push({
                id: outlet.id,
                name: outlet.name,
              });
            }
          });
          return {};
        });
      });
    },

    getStatus() {
      this.filterArray.forEach((filter) => {
        if (filter.header === "Status") {
          filter.optionsBox.push(
            {
              id: "pending",
              name: "Pending",
            },
            {
              id: "approved",
              name: "Approved",
            },
            {
              id: "disapproved",
              name: "Disapproved",
            }
          );
        }
      });
    },

    closeFilter(val) {
      if (val) {
        this.filterTable = false;
      }
    },

    searchFilter(params) {
      this.getRequests(params);
      this.filterTable = false;
    },
  },
  mounted() {
    this.requestAdvance();
    this.getAllFunctions();
    this.getAllDesignations();
    this.getAllLocations();
    this.getAllLevels();
    this.getStatus();
    // this.getStats();
  },
};
</script>

<style scoped>
.icon {
  width: 24px;
  height: 24px;
  padding: 3px;
}
.card {
  border-radius: 5px;
  box-shadow: 0px 1px 2px rgba(45, 49, 66, 0.06), 0px 1px 3px rgba(8, 7, 8, 0.1);
  background-color: #3454d1;
}
.icon-stat{
  width: 100% !important;
  height: 100% !important;
}
.m-top{
  padding-top: -16px !important;
}
</style>